import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ProfileResolver  {

  constructor(private authService: AuthService) {
  }

  resolve() {
    return this.authService.getCurrentUser();
  }
}
